class LikeList {
  constructor(selector, rootElement = document) {
    rootElement.querySelectorAll(selector).forEach((element) => {
      element.addEventListener('click', (e) => {
        this.renderLikeListOther(e.currentTarget);
      });
    });
  }
  toBool(str) {
    if (typeof str != 'string') {
      return Boolean(str);
    }
    try {
      var obj = JSON.parse(str.toLowerCase());
      return obj == true;
    } catch (e) {
      return str != '';
    }
  }
  renderLikeListOther(ele) {
    let likeableType;
    let likeableId;
    let targetElementId;
    let requestUrl = location.origin + '/likes.json';

    if (ele.id) {
      var params = ele.id.split('-');
      likeableType = params[0];
      likeableId = params[1];
      targetElementId = '#' + likeableType + '_' + likeableId;

      let bodyParam = {
        likeable_type: likeableType,
        likeable_id: likeableId,
      };

      let query = new URLSearchParams(bodyParam);
      fetch(`${requestUrl}?${query}`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          $(targetElementId).find('.c-like-list--item').remove();
          var users = data.find(
            (reaction) => !reaction.community_reaction
          ).users;
          if (users) {
            for (var i = 0; i < users.length; i++) {
              var _nickname = users[i]['nickname'];
              var _url = users[i]['url'];
              var _avatar_url = users[i]['avatar_url'];
              var _discard = this.toBool(users[i]['discard']);

              var cLikeListItem = document.createElement('div');
              cLikeListItem.setAttribute('class', 'c-like-list--item');

              var cLikeListInfo = document.createElement('div');
              cLikeListInfo.setAttribute('class', 'c-like-list--info');

              var cLikeListAvatar = document.createElement('div');
              cLikeListAvatar.setAttribute('class', 'c-like-list--avatar');

              var avatarUrl = document.createElement('img');
              avatarUrl.setAttribute('src', _avatar_url);
              avatarUrl.setAttribute('alt', 'ユーザー画像');

              var cLikeListUser = document.createElement('div');
              cLikeListUser.setAttribute('class', 'c-like-list--user');

              var cLikeListUserName = document.createElement('span');
              cLikeListUserName.setAttribute(
                'class',
                'c-like-list--user__name'
              );
              var nickname = document.createElement('span');
              nickname.textContent = _nickname;

              if (_discard) {
                cLikeListAvatar.appendChild(avatarUrl);
                cLikeListUserName.appendChild(nickname);
              } else {
                var userUrl1 = document.createElement('a');
                userUrl1.setAttribute('href', _url);
                userUrl1.setAttribute('class', 'p-post-user__avatar');
                userUrl1.appendChild(avatarUrl);
                const avatarEquipedBadge = users[i]['equiped_badges'].find(
                  (badge) => badge.position == 'avatar'
                );
                if (avatarEquipedBadge) {
                  var avatarBadgeImg = document.createElement('img');
                  avatarBadgeImg.setAttribute(
                    'src',
                    avatarEquipedBadge.image_url
                  );
                  avatarBadgeImg.setAttribute(
                    'class',
                    'p-post-user-avatar__badge-image'
                  );
                  avatarBadgeImg.setAttribute('alt', 'バッジ画像');
                  userUrl1.classList.add('--with-badge');
                  userUrl1.appendChild(avatarBadgeImg);
                }
                cLikeListAvatar.appendChild(userUrl1);
                var userUrl2 = document.createElement('a');
                userUrl2.setAttribute('href', _url);
                userUrl2.setAttribute('class', 'c-like-list__nickname');
                userUrl2.appendChild(nickname);
                if (users[i]['image_badge_url']) {
                  var badgeImg = document.createElement('img');
                  badgeImg.setAttribute('src', users[i]['image_badge_url']);
                  badgeImg.setAttribute(
                    'class',
                    'c-like-list-nickname__badge-image'
                  );
                  userUrl2.appendChild(badgeImg);
                } else {
                  const nicknameEquipedBadge = users[i]['equiped_badges'].find(
                    (badge) => badge.position == 'nickname'
                  );
                  if (nicknameEquipedBadge) {
                    var nicknameBadgeImg = document.createElement('img');
                    nicknameBadgeImg.setAttribute(
                      'src',
                      nicknameEquipedBadge.image_url
                    );
                    nicknameBadgeImg.setAttribute(
                      'class',
                      'c-like-list-nickname__badge-image'
                    );
                    nicknameBadgeImg.setAttribute('alt', 'バッジ画像');
                    userUrl2.appendChild(nicknameBadgeImg);
                  }
                }
                cLikeListUserName.appendChild(userUrl2);
              }

              cLikeListUser.appendChild(cLikeListUserName);

              cLikeListInfo.appendChild(cLikeListAvatar);
              cLikeListInfo.appendChild(cLikeListUser);

              cLikeListItem.appendChild(cLikeListInfo);
              $(targetElementId)
                .find('.c-like-list--modal__body')
                .append(cLikeListItem);
            }
          }
        });
    }
  }
}

export { LikeList };
